<template>
  <el-cascader ref="cascader" v-model="value"
               :options="options"
               :props="props"
               @change="change"
               :placeholder="placeholder"
               :style="css"
               :key="isResourceShow"
               filterable
               size="small"
               clearable>
  </el-cascader>
</template>

<script>
import { getCategoryList } from "@/api/query";
export default {
  name: "CategoryCas",
  props: {
    css: {
      type: Object,
      default: () => {
        return { width: "85%" };
      }
    },
    props: {
      type: Object,
      default: () => {
        return { expandTrigger: "hover" };
      }
    },
    placeholder: {
      type: String,
      default: "请选择分类"
    },
    deep: {
      type: Number,
      default: 0
    },
    fArray: {
      type: Array,
      default: () => {
        return [];
      }
    },
    shopId: [String,Number],
  },
  data() {
    return {
      value: "",
      options: [],
      isResourceShow: 0
    };
  },
  watch: {
    shopId: {
      deep: true,
      handler(val) {
        this.getCategory()
      }
    }
  },
  mounted() {
    this.getCategory();
  },
  methods: {
    // 获取分类
    getCategory() {
      getCategoryList({status:4,shopId:this.shopId}).then(d => {
        let data = d.data;
        data.forEach(item => {
          item.value = item.id;
          item.label = item.name;
        });
        ++this.isResourceShow;
        this.options = this.formatTree(data,this.fArray,this.deep);
      });
    },
    change(value) {
      // let name=this.$refs['cascader'].getCheckedNodes().length==0?'':this.$refs['cascader'].getCheckedNodes()[0].label
      // this.$emit("getCategory",value,name);
      // console.log(this.$refs['cascader'].getCheckedNodes()[0]);
      // console.log(value);
      //取消已选中的
      if(Array.isArray(value)&&value.length==0){       // 多选 取消勾选
        this.options=this.setNoDisabled(this.options)
        this.$emit("getCategory",value);
      }else{
        let a=this.$refs['cascader'].getCheckedNodes();
        if(this.props.multiple){    //多选
          let level=a.length==0?'':a[0].level;
          this.options=this.setLevelDisabled(this.options,level)
          this.$emit("getCategory",value,a[0].level);
        }else{                    //单选
          let name=a.length==0?'':a[0].label
          this.$emit("getCategory",value,name);
        }

      }

    },
    reset() {
      this.value = "";
      ++this.isResourceShow;
      this.$refs.cascader.handleClear();
    },
    setLevelDisabled(data,level){
      let tree = [];
      data.forEach(item => {
        if (item.level != level) {
          item.disabled = true
        }
        item.children&&this.setLevelDisabled(item.children,level)
        tree.push(item)
      })
      return tree;
    },
    setNoDisabled(data){
      let tree = [];
      data.forEach(item => {
        // console.log(item.children);
        item.disabled = false
        item.children&&this.setNoDisabled(item.children)
        tree.push(item)
      })
      return tree;


    }

  }
};
</script>




// WEBPACK FOOTER //
// src/components/CategorySelect/index.vue